/**
 * DQ-475: the insurer id of a policy, whatever shape the API served it in.
 *
 * `Policy.insurer` is typed as a string id, but some policy payloads nest the
 * insurer as an object. `String(object)` is "[object Object]", which the
 * locator then sent to the API as an insurer id.
 */
export function insurerIdOf(insurer: unknown): string | undefined {
  if (typeof insurer === 'string' || typeof insurer === 'number') {
    const text = String(insurer).trim();
    return text || undefined;
  }
  if (insurer && typeof insurer === 'object' && 'id' in insurer) {
    return insurerIdOf((insurer as { id: unknown }).id);
  }
  return undefined;
}
